import React from 'react';
import gql from 'graphql-tag';
import client from '../../../utils/apolloClient';

const getMenuWithoutMenuHoursSchedulersQuery = gql`
  query get_menu_without_menu_hours_schedulers($input: SearchInput) {
    get_menu_without_menu_hours_schedulers(input: $input) {
      total_pages
      total_size
      menu_hours_schedulers_listing {
        menus {
          menu_id
          description
          internal_name
          name
          platform
          private_menu
          slug
          service_type
          publish_menu
          status
          error {
            description
            code
            object {
              id
              name
              type
            }
          }
          menu_hour {
            day
            is_active
            option {
              end
              end_in_sec
              start
              start_in_sec
            }
          }
        }
        place_name
      }
    }
  }
`;

export const fetchData = async ({ from, size = 50, placeName = null }) => {
  const input = {
    // sort: 'DATE_TIME_BY_ASC',
    size,
    from,
    // filter: {
    //   table_booking_filter: {},
    //   place_filter: {},
    // },
  };

  if (placeName) {
    input.place_id = placeName;
  } else {
    input.place_id = '';
  }

  try {
    const data = await client.clientPrivate.query({
      client: client.clientPrivate,
      query: getMenuWithoutMenuHoursSchedulersQuery,
      variables: {
        input,
      },
      fetchPolicy: 'network-only',
    });

    if (
      Array.isArray(
        data?.data?.get_menu_without_menu_hours_schedulers
          ?.menu_hours_schedulers_listing,
      ) &&
      data.data.get_menu_without_menu_hours_schedulers
        .menu_hours_schedulers_listing.length !== 0
    ) {
      return data.data.get_menu_without_menu_hours_schedulers;
    }

    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const useData = ({
  from,
  size = 50,
  placeName = null,
  triggerRerender,
}) => {
  const [loading, setloading] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [totalSize, setTotalSize] = React.useState(0);
  const [totalPages, setTotalPages] = React.useState(0);

  React.useEffect(() => {
    let loadData = true;
    const fetchFunc = async () => {
      setloading(true);
      setData([]);
      setTotalSize(0);
      setTotalPages(0);
      try {
        const res = await fetchData({
          placeName,
          from,
          size,
        });
        if (loadData) {
          if (res && res?.menu_hours_schedulers_listing) {
            setData(res.menu_hours_schedulers_listing);
            setTotalSize(res.total_size);
            setTotalPages(res.total_pages);
          } else {
            setTotalSize(0);
            setTotalPages(0);
          }
        } else {
          // pass
        }
      } catch {
        setloading(false);
        setTotalSize(0);
        setTotalPages(0);
      }
      setloading(false);
    };

    fetchFunc();

    return () => {
      loadData = false;
    };
  }, [from, size, placeName, triggerRerender]);

  return [
    loading,
    data,
    totalSize,
    totalPages,
    async () => {
      try {
        const res = await fetchData({
          from,
          size,
          placeName,
        });

        return res && res?.menu_hours_schedulers_listing
          ? res.menu_hours_schedulers_listing
          : [];
      } catch {
        // pass
      }
      return [];
    },
  ];
};

export default {};
